import {
  GridRow,
  Labels,
  GridPresetTwoThirds,
  PublishedAndUpdated,
  PrintAndShare,
  OptimizelyEditProperty,
  GridPresetSidebar,
  InfobotAITeaser,
} from "/App.Components";
import { HeroBasicProps } from "/App.GeneratedTypes";
import "./HeroBasic.scss";
import { createSpreadableBem } from "/Helpers/createBem";

interface Props extends HeroBasicProps {
  theme?: undefined | "insight";
}

const HeroBasic = ({
  labels,
  heading,
  headingPropertyName,
  leadText,
  leadTextPropertyName,
  publishedAndUpdated,
  printAndShare,
  cta,
  theme,
}: Props) => {
  const showPrintAndShare =
    printAndShare &&
    (!printAndShare.hidePrintButton || !printAndShare.hideShareButton);
  const bem = createSpreadableBem("hero-basic-norad");
  return (
    <div {...bem("", { "--theme-insight": theme === "insight" })}>
      <GridRow>
        <GridPresetTwoThirds>
          {labels && (
            <div {...bem("__tags", { "--theme-insight": theme === "insight" })}>
              <Labels {...labels} />
            </div>
          )}
          <OptimizelyEditProperty propertyName={headingPropertyName}>
            {heading && <h1 {...bem("__heading")}>{heading}</h1>}
          </OptimizelyEditProperty>
          <OptimizelyEditProperty propertyName={leadTextPropertyName}>
            {leadText && <p {...bem("__lead-text")}>{leadText}</p>}
          </OptimizelyEditProperty>
          {(publishedAndUpdated || showPrintAndShare) &&
            theme !== "insight" && (
              <div {...bem("__byline")}>
                {publishedAndUpdated && (
                  <PublishedAndUpdated {...publishedAndUpdated} />
                )}
                {publishedAndUpdated && showPrintAndShare && (
                  <div {...bem("__byline-divider")} />
                )}
                {showPrintAndShare && <PrintAndShare {...printAndShare} />}
              </div>
            )}
        </GridPresetTwoThirds>
        {cta && theme !== "insight" && (
          <GridPresetSidebar>
            <InfobotAITeaser {...cta} theme={InfobotAITeaser.Theme.Hero} />
          </GridPresetSidebar>
        )}
      </GridRow>
    </div>
  );
};

export default HeroBasic;
